/**
 * @description 自定义的分享浮层
 * @author aprilcai
 */

const shareStyle = `
  .iv-txv-pc-share-panel {
    z-index: 1000;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.8);
  }
  .iv-txv-pc-share-panel .image {
    position: absolute;
    object-fit: contain;
    width: 60vw;
    height: 60vh;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
  .iv-txv-pc-share-panel .close-btn {
    position: absolute;
    left: 30px;
    top: 20px;
    width: 40px;
    height: 40px;
    z-index: 100000;
    background-size: cover;
    background-image: url(https://puui.qpic.cn/vupload/0/1567069102477_m58qz2c23qo.png/0);
  }
`;

const pcSharePanel = {
  create: (param: {
    pcShareImageUrl?: string;
    pcShareImageWidth?: string;
    pcShareImageHeight?: string;
  }) => {
    if (!param.pcShareImageUrl) return;
    if (!document.querySelector('#__bridge_helper_style')) {
      const style = document.createElement('style');
      style.textContent = shareStyle;
      style.type = 'text/css';
      style.id = '__bridge_helper_style';
      document.head.appendChild(style);
    }
    const el = document.createElement('div');
    el.classList.add('iv-txv-pc-share-panel');
    document.body.appendChild(el);
    const image = document.createElement('img');
    image.src = param.pcShareImageUrl;
    const width = param.pcShareImageWidth || '100%';
    const height = param.pcShareImageHeight || '100%';
    image.style.width = width;
    image.style.height = height;
    image.classList.add('image');
    el.appendChild(image);
    const closeBtn = document.createElement('div');
    el.appendChild(closeBtn);
    closeBtn.classList.add('close-btn');
    closeBtn.addEventListener('click', () => {
      el.remove();
    });
  },
};

export default pcSharePanel;
